export default __webpack_public_path__ + "static/media/premium_card_1@2x.07147944.png";